import CheckCircleIcon from "@redotech/redo-icons/check-circle.svg";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";

export const IncompleteVerificationModal = memo(
  function IncompleteVerificationModal({
    onContinue,
    onBack,
    open,
  }: {
    onContinue: () => void;
    onBack: () => void;
    open: boolean;
  }) {
    return (
      <RedoModal
        isOpen={open}
        modalSize="sm"
        onModalCloseRequested={onBack}
        primaryButton={{
          text: "Proceed to next order",
          onClick: onContinue,
          size: "sm",
        }}
        secondaryButton={{ text: "Cancel", onClick: onBack, size: "sm" }}
        subtitle="This order hasn’t been fully verified. Are you sure you want to leave this order without completing verification?"
        theme="success"
        title="Proceed to next order?"
        TitleIcon={CheckCircleIcon}
      />
    );
  },
);
